import React, { useContext, useEffect, useState } from 'react';
import { VegaFlex, VegaButtonLink, VegaIcon, VegaDivider, VegaButton, VegaRichTextContent, VegaCard } from "@heartlandone/vega-react";
import { VegaDialog, VegaIconManager, VegaNotify } from "@heartlandone/vega";
import { useLocation, useLoaderData, useNavigate } from 'react-router-dom';
import { useNavigationHistory } from 'Navigation/NavigationHistoryProvider';
import Avatar from 'Components/Avatar';
import Carousel from 'Components/Carousel/Carousel';
import ActivityStateindicator from 'Components/ActivityStateindicator/ActivityStateindicator';
import './ActivityList/module.css';
import { HubContext } from 'Redux/Context/context';
import { FORM_NAME } from 'Chore/Constants';
import { openFormAction, toggleGlobalModalAction } from 'Redux/Actions/actions';
import {_fetch} from 'Chore/Request';
import { PATH } from 'Chore/Apis';
import CountDown from 'Components/CountDown/CountDown';
import Rating from 'Components/Rating/Rating.js';
import FeedbackList from 'Components/FeedBackList/FeedbackList';
import './Css/rating-bar.css';
import pdf from 'assets/icons/pdf.png';
import excel from 'assets/icons/excel.png';
import word from 'assets/icons/word.png';
import ppt from 'assets/icons/ppt.png';
import jpg from 'assets/icons/jpg.png';
import mp3 from 'assets/icons/mp3.png';
import mp4 from 'assets/icons/mp4.png';
import zip from 'assets/icons/zip.png'; 
import ActivityTimeRange from 'Views/MyActivity/ActivityInformations/TimeRange';
import RegistrationTimeRange from 'Views/MyActivity/ActivityInformations/RegistrationTimeRange';
import hourglassClock from 'assets/icons/hourglass-clock.svg';
import { isActivityFullyBooked } from "Chore/Utils";


import { ACTIVITY_STATUS, ROLE_NAME_MAPPING } from 'Chore/Constants';
const { STATUS_LABEL } = ACTIVITY_STATUS;

const { GET_ACTIVITY, FAVORITE_ACTIVITY, ADD_GET_FEEDBACK, CANCEL_REGISTER, DELETE_ACTIVITY } = PATH; 

VegaIconManager.register({
  "customIcon": {
    autoSize: true,
    icon: '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="24" fill="none"><rect width="36" height="24" fill="#00579F" rx="2"/><path fill="#fff" d="M15.474 15.792h-1.979l1.238-7.653h1.979l-1.238 7.653ZM22.647 8.326A4.877 4.877 0 0 0 20.872 8c-1.954 0-3.33 1.042-3.339 2.532-.016 1.1.986 1.71 1.735 2.076.765.375 1.026.62 1.026.953-.008.513-.619.75-1.189.75-.79 0-1.213-.123-1.857-.408l-.26-.122-.277 1.718c.464.211 1.32.4 2.207.407 2.076 0 3.428-1.026 3.444-2.613.008-.872-.52-1.54-1.66-2.085-.693-.35-1.117-.586-1.117-.944.008-.326.359-.66 1.14-.66a3.362 3.362 0 0 1 1.474.293l.18.082.268-1.653ZM25.279 13.08l.79-2.14c-.008.016.162-.448.26-.733l.138.66s.375 1.831.457 2.214h-1.645ZM27.72 8.14h-1.53c-.472 0-.831.138-1.035.635l-2.94 7.018h2.077l.416-1.148h2.54c.057.269.237 1.148.237 1.148h1.832L27.72 8.14ZM11.842 8.139l-1.938 5.219-.212-1.059c-.358-1.221-1.482-2.548-2.736-3.208l1.775 6.693h2.093l3.11-7.645h-2.092Z"/><path fill="#FAA61A" d="M8.104 8.139H4.92l-.032.154c2.483.635 4.128 2.166 4.804 4.007L9 8.782c-.114-.489-.464-.627-.896-.643Z"/></svg>',
  },
});

function ActivityDetail() {
  const location = useLocation();
  const params = useLoaderData();
  const navigate = useNavigate();
  const { formDispatch, globalModalDispatch, dashboardBasicDataState, userInfoState : { userInfo } } = useContext(HubContext);
  const [activity, setActivity] = useState({});
  const [isFavorite, setIsFavorite] = useState(false);
  const [feedbacks, setFeedbacks] = useState([]);
  const { goBack } = useNavigationHistory();

  const getActivityImageUrls = (imageUrls = []) => {
    const imageList = [];

    if (imageUrls.length>0){
      imageUrls.forEach((image) => {
        imageList.push(image?.url);
      });
    }
    return imageList;
  }

  const checkUserRegistrationEligibility = (activity, currentUserRole) => {
    if (activity.registerNumberLimitType !== 'Limited') {
      return { eligible: true };
    }

    if (!activity.isTeamRecruitmentActivity) {
      if (activity.participantsCount >= activity.registerNumberLimit) {
        return { 
          eligible: false,
          message: 'The number of registrations is full.' 
        };
      }
      return { eligible: true };
    } else {
        if (activity.activityAllowRoles?.length > 0) {
          const allowedRole = activity.activityAllowRoles.find(
            role => role.roleId === currentUserRole
          );
          
          if (!allowedRole) {
            return {
              eligible: false,
              message: 'This event only accepts registrations for specified roles. Your registration does not meet the requirements.'
            };
          }

          if (allowedRole.participantsCount >= allowedRole.numbers) {
            return {
              eligible: false,
              message: 'The number of registrations is full.'
            };
          }
        }
    }

    return { eligible: true };
  };

  const OnRigisterButtonClick = (e) => {
    e.preventDefault();
    
    const currentUserRole = userInfo?.positionCategoryId;
    const { eligible, message } = checkUserRegistrationEligibility(activity, currentUserRole);
    
    if (!eligible) {
      VegaDialog.open({ content: message, showCancel: false });
      return;
    }

    formDispatch(openFormAction({ 
      name: FORM_NAME['REGISTER_FORM'], 
      activity: { activity }, 
      isEdit: false 
    }));
  };

  const OnCancelRigisterButtonClick = () => {
    VegaDialog.open({
      title: "Cancel Registration",
      content: "Are you sure you want to cancel your registration for the activity?",
      okButton: { label: "Yes", size: "small" },
      cancelButton: { label: "No", size: "small" },
      handleOk: async () => {
        cancelRegistration();
        return true;
      },
    });
  }

  const cancelRegistration = () => {
    _fetch({
      api: CANCEL_REGISTER(activity.id),
      method: 'DELETE'
    })
    .then(res => {
      if(res.code === 2200){
        VegaNotify.open({
          type: 'success',
          message: 'The registration has been cancelled.'
        });
  goBack('/');
      } else {
        VegaNotify.open({
          type: 'error',
          message: 'The registration could not be cancelled.'
        });
      }
    })
  }

  const OnDeleteActivityButtonClick = () => {
    VegaDialog.open({
      title: "Delete Activity",
      content: "Are you sure to delete the activity?",
      handleOk: async () => {
        deleteActivity();
        return true;
      },
      isVerticallyCentered: true,
    });
  }

  const deleteActivity = () => {
    _fetch({
      api: DELETE_ACTIVITY(activity.id),
      method: 'DELETE'
    }).then(res => {
      if (res.code === 2200) {
        VegaNotify.open({
          type: 'success',
          message: 'Delete succeeded'
        });
        navigate('/');
      } else {
        VegaNotify.open({
          type: 'error',
          message: 'Delete failed'
        });
      }
    });
  };

  useEffect(() => {
    const { id } = params;
    _toggleModal(true);
    _fetch({
      api: `${GET_ACTIVITY}/${id}`
    })
    .then(res => {
      if(res.code === 2200){
        var activity= res?.payload;
        setActivity(activity);
        setIsFavorite(activity?.hasFavorited);
      }
    }).finally(() => {
      _toggleModal();
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  const formatAmount = (number) =>{
    if(number === null || number === undefined || number === "")
      return '0';
    else 
      return number;
  };
 
 const _toggleFavoriteState = () => {
    _toggleModal(true);
    _fetch({
      method: 'POST',
      data: {isFavorite: !isFavorite},
      api: FAVORITE_ACTIVITY(activity.id),
    }).then(res => {
      if(res.code === 2200){
        setIsFavorite(res?.payload);
      }
    }).finally(() => {
      _toggleModal();
    });
  };

  const _toggleModal = (isShow = false) => {
    globalModalDispatch(toggleGlobalModalAction({isShow}));
  }

  useEffect(() => {
    if (!isNaN(activity.id)) {
      _fetch({
        api: ADD_GET_FEEDBACK(activity.id),
        method: 'GET'
      })
      .then(res => {
        if(res.code === 2200){
          setFeedbacks([...res?.payload]);
        }
      });
    }
  }, [activity])

  const _isExpired = () => {
    return Date.now() >= new Date(activity.endTime).getTime();
  }

  const _isNotStartRegoster= () => {
    const NOW = Date.now();

    return NOW < new Date(activity.registerStartTime).getTime();
  }

  const permissions = dashboardBasicDataState?.permissions || [];
  const isAdmin = Array.isArray(permissions) && permissions.includes('Module.ActivityHub.CompanyActivity.Create');
  const isOwner = (!!activity?.createdUserId && !!userInfo?.userId && activity.createdUserId === userInfo.userId);

  const _renderButton = () => {
    let buttons = [];
    
    if (_isExpired() || activity.activityStatus === STATUS_LABEL.CLOSED) {
      buttons.push(
        <VegaButton
          key="status"
          label="Registration Closed"
          variant="primary"
          size="default"
          disabled={true}
        />
      );
    } else if (!activity.hasRegistered && isActivityFullyBooked(activity)) {
      buttons.push(
        <VegaButton
          key="status"
          label="Fully Booked"
          size="default"
          disabled={true}
          variant="primary"
          className="fully-booked"
        />
      );
    } else if (_isNotStartRegoster()) {
      buttons.push(
        <VegaButton
          key="status"
          label="Register Now"
          size="default"
          disabled={true}
          variant="primary"
        />
      );
    } else if (!_isExpired() && !activity.hasRegistered) {
      buttons.push(
        <VegaButton
          key="status"
          label="Register Now"
          size="default"
          variant="primary"
          iconAlign="right"
          onVegaClick={OnRigisterButtonClick}
        />
      );
    } else if (!_isExpired() && activity.hasRegistered) {
      buttons.push(
        <VegaButton
          key="status"
          label="Cancel Registration"
          variant="secondary"
          icon="close"
          size="default"
          iconAlign="left"
          onVegaClick={OnCancelRigisterButtonClick}
        />
      );
    }

    if (isOwner || isAdmin) {
      buttons.push(
        <VegaButton
          key="manage"
          label="Manage Registration"
          variant="secondary"
          size="default"
          onVegaClick={() => {
            navigate(`/activityInfo/published/${activity.id}`);
          }}
        />
      );

      buttons.push(
        <VegaButton
          key="remove"
          label="Remove Activity"
          variant="secondary"
          size="default"
          danger={true}
          onVegaClick={OnDeleteActivityButtonClick}
        />
      );
    }
    
    return (
      <VegaFlex gap="size-8">
        {buttons}
      </VegaFlex>
    );
  };

  const _openFile = (url) => {
    // Open the URL in a new tab
    window.open(`${url}?download=true`, '_blank', 'noopener,noreferrer');
  };

  const getFileType = (fileName) => {
    if (fileName.endsWith('.pdf')) {
      return pdf;
    } else if (fileName.endsWith('.xlsx') || fileName.endsWith('.xls')) {
      return excel;
    } else if (fileName.endsWith('.docx') || fileName.endsWith('.doc') || fileName.endsWith('.txt') || fileName.endsWith('.csv')) {
      return word;
    } else if (fileName.endsWith('.pptx') || fileName.endsWith('.ppt')) {
      return ppt;
    } else if (fileName.endsWith('.mp3') || fileName.endsWith('.wav') || fileName.endsWith('.wma')) {
      return mp3;
    } else if (fileName.endsWith('.mp4') || fileName.endsWith('.avi') || fileName.endsWith('.wmv') || fileName.endsWith('.mov')) {
      return mp4;
    } else if (fileName.endsWith('.zip') || fileName.endsWith('.rar') || fileName.endsWith('.7z')) {
      return zip;
    } else if (fileName.endsWith('.png') || fileName.endsWith('.jpeg') || fileName.endsWith('.jpg') || fileName.endsWith('.gif') || fileName.endsWith('.bmp')) {
      return jpg;
    }
    return zip;
  }

  const getRoleShortName = (roleId, type = 'long') => {
    const { positionClassifications = [] } = dashboardBasicDataState;
    const role = positionClassifications.find(role => role.id === roleId);
    return type === 'long' ? role?.name : ROLE_NAME_MAPPING[role?.name] || '';
  }

  const getRoleLogo = (roleId) => {
    const { positionClassifications = [] } = dashboardBasicDataState;
    const role = positionClassifications.find(role => role.id === roleId);
    return role?.icon || '';
  }

  return (
    <VegaFlex direction={'col'}>
      <VegaFlex className='m-b-24'>
        <VegaButtonLink
            label="Back"
            icon="fa-solid fa-angle-left"
            onVegaClick={() => goBack('/')}
        />
      </VegaFlex>
      <VegaFlex direction={'col'} gap={'size-12'} className='m-b-24'>
        <VegaFlex direction={'row'} justifyContent={'space-between'}>
          <h1 className='m-0'>{activity.title}</h1>
          { activity?.id && _renderButton() }
        </VegaFlex>
        <VegaFlex alignItems={"center"} gap={'size-16'}>
          <VegaFlex gap={'size-8'} alignItems={"center"}>
            <Avatar width='size-20' name={activity.createdBy} avatarUrl={activity.createdByAvatarUrl}></Avatar>
            <span className='m-0'>{activity.createdBy}</span>
          </VegaFlex>
          <div className="vertical-divider"></div>
            <ActivityTimeRange startTime={activity.startTime} endTime={activity.endTime}></ActivityTimeRange>
          <div className="vertical-divider"></div>
            <RegistrationTimeRange startTime={activity.registerStartTime} endTime={activity.registerDeadline}></RegistrationTimeRange>
          <div className="vertical-divider"></div>
          <div>
            <VegaIcon size={'size-16'} icon={activity.isOnlineActivity ? 'fa-sharp fa-regular fa-presentation-screen' : 'far fa-location-dot'} className={'font-light-text-color-secondary'}></VegaIcon>
            {activity?.id && <span className='m-l-12 font-light-text-color-secondary'>{activity.isOnlineActivity ? "Online Activity" : `${activity.city} - ${activity.address}` }</span>}
          </div>
          <div className="vertical-divider"></div>
          <div>
            <ActivityStateindicator activityStatus={activity.activityStatus}/>
          </div>
        </VegaFlex>
      </VegaFlex>
      {
        (activity?.videoUrls?.length > 0 || activity?.images?.length > 0) && <VegaFlex>
          <Carousel urls ={{videos: activity?.videoUrls, images: getActivityImageUrls(activity?.images)}} />
        </VegaFlex>
      }
      <VegaFlex gap={'size-16'}  className='m-t-32'>
        <VegaFlex direction={'col'} gap={'size-24'} style={{ width: '100%' }}>
          <VegaFlex direction={'col'} gap={'size-16'}>
            <VegaFlex  justifyContent={'space-between'} alignItems={'center'}>
              <p className='f-weight-700 f-size-20 line-height-28 font-light-text-color-primary m-0'>Activity Description</p>
              <VegaFlex  onClick={_toggleFavoriteState}>
                <VegaIcon
                  icon="fa-solid fa-heart"
                  size="size-16"
                  className={`${isFavorite ? 'font-dark-Background-Accent6-Primary' : 'font-light-Background-Toogle-Switch'} pointer`}
                />
              </VegaFlex>
            </VegaFlex>
            
            {
              activity?.descriptionObject?.length && <VegaCard>
                <VegaRichTextContent content={activity?.descriptionObject}></VegaRichTextContent>
              </VegaCard>
            }
          </VegaFlex>
          
          <VegaFlex direction={'col'} gap={'size-32'} className={`${(!!activity?.documents && activity?.documents.length > 0)? "" : " display-none"}`}  justifyContent={'space-between'}>
            <VegaDivider/>
            <h4 className='f-weight-700 f-size-20 line-height-28 font-light-text-color-primary m-0'>Attachment</h4>
          </VegaFlex>
          {(activity?.documents || []).map((file, index) => {
            return <VegaFlex key={`${index}-${Date.now()}`} gap={'size-16'}>
                <img src={getFileType(file.originalFileName)} style={{ width: 24, height: 24 }} alt=''/>
                <span className={'f-size-14 f-weight-400 line-height-18 font-light-text-color-primary'}>{file.originalFileName}</span>
                <VegaButtonLink icon="far fa-download" onVegaClick={()=> _openFile(file.url)}/>
              </VegaFlex>
           })}
           {
            _isExpired() && (
              <>
                <VegaDivider />
                <VegaFlex direction={"col"} gap={'size-32'}>
                  <Rating rates={feedbacks.map((f) => f.rating )}/>
                  <FeedbackList feedbacks={feedbacks}/>
                </VegaFlex>
              </>
            )
           }
        </VegaFlex>
        <VegaFlex direction={'col'}  style={{ width: '25%' }} gap={'size-24'}>
          <VegaFlex className='meta-data p-24 bg-light-Background-Secondary round-12' gap={'size-16'} alignItems={'flex-start'}>
            <img src={hourglassClock} alt="Reg Count Down" style={{ width: 30, height: 24 }} />
            <VegaFlex direction={'col'} gap={'size-8'}>
              <span className='f-weight-700 line-height-18 f-size-14 font-light-text-color-primary'><CountDown timeStamp={new Date(activity.registerDeadline).getTime()} activity={activity}/></span>
              <span className='f-weight-400 line-height-16 f-size-14 font-light-text-color-secondary'>Reg Count Down</span>
            </VegaFlex>
          </VegaFlex>
          <VegaFlex className='meta-data p-24 bg-light-Background-Secondary round-12' gap={'size-16'} alignItems={'flex-start'}>
            <VegaIcon size={'size-24'} icon='fa-duotone fa-solid fa-coins' style={{ width: 30 }}></VegaIcon>
            <VegaFlex direction={'col'} gap={'size-8'}>
              <span className='f-weight-700 line-height-18 f-size-14 font-light-text-color-primary'>{activity.chargeAmount ===0 ? "Free" : "$" +formatAmount(activity.chargeAmount)}</span>
              <span className='f-weight-400 line-height-16 f-size-14 font-light-text-color-secondary'>Cost</span>
            </VegaFlex>
          </VegaFlex>
          {
            !activity?.isTeamRecruitmentActivity && <VegaFlex className='meta-data p-24 bg-light-Background-Secondary round-12' gap={'size-16'} alignItems={'flex-start'}>
              <VegaIcon size={'size-24'} icon='fad fa-users-viewfinder' style={{ width: 30 }}></VegaIcon>
              <VegaFlex direction={'col'} gap={'size-8'}>
                <span className='f-weight-700 line-height-18 f-size-14 font-light-text-color-primary'>Participants({activity.participantsCount}{activity.registerNumberLimitType === 'Limited' ? ` / ${activity.registerNumberLimit}` : ''})</span>
                <span className='f-weight-400 line-height-16 f-size-14 font-light-text-color-secondary'>{activity.registerNumberLimitType === 'Limited' ? 'Register Limit' : 'Unlimited'}</span>
              </VegaFlex>
            </VegaFlex>
          }
          {
            (!activity?.isTeamRecruitmentActivity && activity?.registerSetting?.isAllowInviteGuests) && <VegaFlex className='meta-data p-24 bg-light-Background-Secondary round-12' gap={'size-16'} alignItems={'flex-start'}>
              <VegaIcon size={'size-24'} icon='fa-duotone fa-solid fa-user-plus' style={{ width: 30 }}></VegaIcon>
              <VegaFlex direction={'col'} gap={'size-8'}>
                <span className='f-weight-700 line-height-18 f-size-14 font-light-text-color-primary'>Guests Allowed</span>
                <span className='f-weight-400 line-height-16 f-size-14 font-light-text-color-secondary'>invite Guest</span>
              </VegaFlex>
            </VegaFlex>
          }
          {
            activity?.isTeamRecruitmentActivity && (
              activity?.activityAllowRoles.map((role) => (
                <VegaFlex className='meta-data p-24 bg-light-Background-Secondary round-12' gap={'size-16'} alignItems={'flex-start'}>
                  <VegaIcon size={'size-24'} icon={getRoleLogo(role.roleId)} style={{ width: 30 }}></VegaIcon>
                  <VegaFlex direction={'col'} gap={'size-8'}>
                    <span className='f-weight-700 line-height-18 f-size-14 font-light-text-color-primary'>{getRoleShortName(role.roleId, 'short')}({role.participantsCount}/{role.numbers})</span>
                    <span className='f-weight-400 line-height-16 f-size-14 font-light-text-color-secondary'>{getRoleShortName(role.roleId)}</span>
                  </VegaFlex>
                </VegaFlex>
              ))
            )
          }
        </VegaFlex>
      </VegaFlex>
    </VegaFlex>
  );
}

export default ActivityDetail;
